<template>
  <div>
    <b-row>
      <b-col>
        <h5>Localisation d'urgence</h5>
        <p>
          S'il est nécessaire de localiser le coureur, il est désormais possible de lui envoyer un SMS sur son smartphone. Il sera invité a cliquer sur un lien qui permettra de vous envoyer sa position. Vous pourrez ensuite localiser le coureur sur
          une carte.
        </p>
        <b-button class="inline-submenu-btn with_icon" @click="opeModalsendSMS(coureur)">
          <b-icon icon="chat-left-text" aria-hidden="true"></b-icon>
          Envoyer un SMS</b-button
        >
        <b-button class="inline-submenu-btn with_icon" :to="{ name: 'CarteLocalisationUrgence' }">
          <b-icon icon="map" aria-hidden="true"></b-icon>
          Consulter les alertes en cours</b-button
        >
      </b-col>
    </b-row>
    <b-modal v-model="show_modal" busy>
      <h5>Demande de localisation</h5>
      <h6>{{ coureur.nom }} {{ coureur.prenom }}</h6>
      <p>Un SMS va être envoyé au coureur. Il sera invité à cliquer sur un lien qui permettra de vous envoyer sa position. Vous pourrez ensuite localiser le coureur sur une carte.</p>
      <hr />

      <b-form>
        <b-row>
          <b-col md="6">
            <label for="">Nom du coureur</label>
            <b-form-input v-model="form_coureur.nom" placeholder="Nom du coureur"></b-form-input>
          </b-col>
          <b-col md="6">
            <label for="">Prénom du coureur</label>
            <b-form-input v-model="form_coureur.prenom" placeholder="Prénom du coureur"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="">Dossard du coureur</label>
            <b-form-input v-model="form_coureur.doss" placeholder="Dossard du coureur"></b-form-input>
          </b-col>
          <b-col md="6">
            <label for="">Tel du coureur</label>
            <b-form-input v-model="form_coureur.tel" placeholder="Tel du coureur"></b-form-input>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="sendSMS()"> Envoyer </b-button>
        <b-button size="sm" variant="danger" @click="cancel()"> Annuler </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["coureur"],
  data() {
    return {
      show_modal: false,
      form_coureur: {
        nom: "",
        prenom: "",
        doss: "",
        tel: "",
      },
    };
  },
  methods: {
    opeModalsendSMS(coureur) {
      this.show_modal = true;
    },
    async sendSMS() {
      this.show_modal = false;
      let request = await axios.post(this.$store.state.base_url + "/sos/sendSMS.php", {
        id_module: this.$store.state.module.id,
        nom: this.form_coureur.nom,
        prenom: this.form_coureur.prenom,
        doss: this.form_coureur.doss,
        tel: this.form_coureur.tel,
      });
      this.$router.push({ name: "CarteLocalisationUrgence" });
      console.log("sendSMS", request);
    },
    reformat_phone(phone) {
      phone = phone.replace(/\s/g, "");
      phone = phone.replace(/-/g, "");
      phone = phone.replace(/\./g, "");
      // Handle french phone
      if (phone.startsWith("6") || phone.startsWith("7")) phone = "33" + phone;
      if (phone.startsWith("06") || phone.startsWith("07")) phone = "33" + phone.substring(1);
      if (phone.startsWith("0033")) phone = phone.substring(2);
      phone = phone.replace(/\+/g, "");

      return phone;
    },
  },
  created() {
    this.form_coureur.nom = this.coureur.nom;
    this.form_coureur.prenom = this.coureur.prenom;
    this.form_coureur.doss = this.coureur.dossard;
    this.form_coureur.tel = this.reformat_phone(this.coureur.tel);
  },
};
</script>

<style lang="scss" scoped>
</style>